import React from 'react'
import styled from '@emotion/styled'
import anime from 'animejs'
import { aspectRatio, aspectRatioChild } from '@/utils/helpers'

class ScrollIcon extends React.Component {
  constructor (props) {
    super(props)
    this.rootRef = React.createRef()
  }
  componentDidMount () {
    const allPaths = this.rootRef.current.querySelectorAll('path')
    this.tl1 = anime.timeline({
      autoplay: true,
      easing: 'easeInOutSine',
      loop: true
    })
    Array.prototype.slice.call(allPaths).forEach((el, index) => {
      this.tl1
        .add({
          targets: el,
          scale: [1, 0.9],
          opacity: [1, 0],
          duration: 200,
          delay: index * 100
        }, 0)
        .add({
          targets: el,
          scale: 1,
          opacity: 1,
          duration: 200
        }, 200 + index * 100)
        .add({
          targets: el,
          scale: 1,
          opacity: 1,
          duration: 200
        }, (200 + index * 100) * 2)
    })
  }
  render () {
    return (
      <Root {...this.props} ref={this.rootRef}>
        <SVG width="45" height="27" viewBox="0 0 45 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.269531 0.419922L22.2695 14.8799L44.2695 0.419922" stroke="#23743A" strokeMiterlimit="10"/>
          <path d="M0.269531 11.4199L22.2695 25.8799L44.2695 11.4199" stroke="#23743A" strokeMiterlimit="10"/>
        </SVG>
      </Root>
    )
  }
}

const Root = styled.span`
  display: block;
  ${aspectRatio(45, 27)};
`

const SVG = styled.svg`
  ${aspectRatioChild};

  path {
    transform-origin: center;
  }
`

export default ScrollIcon
